import { Directive, HostListener, Input } from '@angular/core';
import { AbstractPreviewOverlayGtmService } from './abstract-preview-overlay-gtm.service';
import { ShallowPreviewOverlayViewModel } from './preview-overlay.view-model';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnSharedPreviewOverlayGtm]',
})
export class PreviewOverlayGtmDirective {
  @Input() public vm: ShallowPreviewOverlayViewModel;
  @Input() public lengthInSeconds: number;
  @Input() public buttonTextForGA: string;

  @HostListener('click', ['$event']) public onClick(e: MouseEvent) {
    this.previewOverlayGtmService.measureButtonClick(this.vm, this.buttonTextForGA);
  }

  constructor(private readonly previewOverlayGtmService: AbstractPreviewOverlayGtmService) {}
}
